<script setup>
import VDevider from "@/Shared/VDevider.vue";

import { OUTBOUND_ENUM } from "../../PublicPage/Survey/tabs.config";
import { computed, ref } from "vue";
import VFormDemographic from "@/Shared/Survey/Outbound/VFormDemographic.vue";
import VFormTravel from "@/Shared/Survey/Outbound/VFormTravel.vue";
import VFormExpense from "@/Shared/Survey/Outbound/VFormExpense.vue";
import VFormAirEntryPoint from "@/Shared/Survey/Outbound/VFormAirEntryPoint.vue";
import VFormFeedbacks from "@/Shared/Survey/Outbound/VFormFeedbacks.vue";
import VFormVacation from "@/Shared/Survey/Outbound/VFormVacation.vue";

const props = defineProps({
    tab: Object,
    surveyFields: Object,
    answers: Object,
});

const emits = defineEmits(["onNext", "onPrev"]);
const form = ref({});

const activeComponent = computed({
    get() {
        switch (props.tab.key) {
            case OUTBOUND_ENUM.FORM_1:
                return {
                    component: VFormDemographic,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case OUTBOUND_ENUM.FORM_2:
                return {
                    component: VFormTravel,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case OUTBOUND_ENUM.FORM_3:
                return {
                    component: VFormVacation,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case OUTBOUND_ENUM.FORM_4:
                return {
                    component: VFormExpense,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case OUTBOUND_ENUM.FORM_5:
                return {
                    component: VFormAirEntryPoint,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
            case OUTBOUND_ENUM.FORM_6:
                return {
                    component: VFormFeedbacks,
                    additional: {
                        surveyFields: props.surveyFields,
                        answers: props.answers,
                    },
                };
        }
    },
});
</script>

<template>
    <div class="row">
        <div class="col-12">
            <KeepAlive>
                <component
                    :is="activeComponent.component"
                    :additional="activeComponent.additional"
                    :isShowSubmit="false"
                />
            </KeepAlive>
        </div>
    </div>
</template>
